package com.imobly.imobly.api.httpclient

import com.imobly.imobly.api.dto.ErrorDTO
import com.imobly.imobly.api.dto.Ok
import com.imobly.imobly.api.dto.ResponseMessage
import com.imobly.imobly.api.getToken
import com.imobly.imobly.domain.Appointment
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.delete
import io.ktor.client.request.get
import io.ktor.client.request.header
import io.ktor.http.isSuccess

class AppointmentHttpClient(val httpClient: HttpClient) {
    val baseUrl = "/agendamentos"

    suspend fun searchAllByTitle(title: String? = ""): List<Appointment> {
        val response = httpClient.get("$baseUrl/encontrartodos?titulo=$title") {
            header("Authorization", "Bearer ${getToken()}")
        }
        return response.body()
    }

    suspend fun delete(id: String): ResponseMessage {
        val response = httpClient.delete("$baseUrl/deletar/$id") {
            header("Authorization", "Bearer ${getToken()}")
        }
        if (response.status.isSuccess()) {
            return Ok()
        }
        return response.body<ErrorDTO>()
    }
}